/**
 * These utilities are for creating and parsing messages between the web app and its native container
 * (namely, React Native).
 */

const MessageTypes = {
  SET_USER_CARD: 'card.setUser',
  SET_CARD: 'card.set'
}

const createMessage = ({ type, payload }) => {
  return JSON.stringify({ type, payload });
};

const parseMessage = (message) => {
  return JSON.parse(message);
};

module.exports = { createMessage, parseMessage, MessageTypes };
